//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {
      questionTitle: '千词斩如何开通会员?',
      answerContent: '请点击[我的] - [添加微信] 识别商家微信添加进行咨询开通'
    };
  },
  created() {
    this.questionTitle = this.$route.query.title;
    this.answerContent = this.$route.query.content;
  },
  methods: {
    goBack() {
      this.$router.push({ path: "cjwt?hideTrans=true" });
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/publicView/me/wtlb_display.vue